import { get } from 'lodash'

import { SpecimenResource, SpecimenIdentifiersResource, TranslatedString, getTranslatedString } from '@skinsoft/types';

export const id = (specimen: SpecimenResource) => get(specimen, 'id');

export const identifiers = (specimen: SpecimenResource): Array<SpecimenIdentifiersResource> | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.identifiers')
}

export const firstIdentifier = (specimen: SpecimenResource): string | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.identifiers.0.identifier.value') ?? get(specimen, 'identificationSpecimenSchema.identifiers.0.identifier') ?? ""
}

export const recolnatId = (specimen: SpecimenResource): string | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.recolnatId.ref') ??
        get(specimen, 'identificationSpecimenSchema.recolnatId')
}

export const specimenType = (specimen: SpecimenResource): string | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.specimenType.ref') ??
        get(specimen, 'identificationSpecimenSchema.specimenType')
}

export const collectionType = (specimen: SpecimenResource): TranslatedString | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.collectionType')
}

export const typeOfDeposit = (specimen: SpecimenResource): TranslatedString | undefined | null => {
    return get(specimen, 'identificationSpecimenSchema.typeOfDeposit')
}

export const firstMediaId = (specimen: SpecimenResource): string | undefined | null => {
    return get(specimen, 'associatedMedias.first.ref') ?? 
    get(specimen, 'associatedMedias.first')
}

export const permanentLocation = (specimen: SpecimenResource) => {
    const res = get(specimen, 'locationItemSchema.permanentLocation.permanentLocation')
    return (res as any)?.ref ?? res
}

export const realTimeLocation = (specimen: SpecimenResource) => {
    const res = get(specimen, 'locationItemSchema.realTimeLocation.realTimeLocation')
    return (res as any)?.ref ?? res
}

export const futureLocation = (specimen: SpecimenResource) => {
    const res = get(specimen, 'locationItemSchema.futureLocation.futureLocation')
    return (res as any)?.ref ?? res
}

export const title = (specimen: SpecimenResource, locale: string): string => {
    const translatedString = get(specimen, 'identificationSpecimenSchema.specimenTitles.0.title')

    if(translatedString) {
        return getTranslatedString(translatedString, locale) ?? ''
    }

    return ''
}

export const identifier = (specimen: SpecimenResource, locale: string) => {
    const barCode = get(specimen, `identificationSpecimenSchema.barCodes.translatedString.${locale}`);

    const uniqueIdentifier = get(specimen, 'identificationSpecimenSchema.identifiers[0].identifier');

    let res = uniqueIdentifier || barCode || "..."

    if((res as any).value) {
        return (res as any).value
    }

    return res
};